var map = {
	"./icon_playing.svg": 524,
	"./thumbnails/02_hero_desktop.jpg": 242,
	"./thumbnails/02_hero_mobile.jpg": 243,
	"./thumbnails/02_hero_tablet.jpg": 244,
	"./thumbnails/04_hero_desktop.jpg": 245,
	"./thumbnails/04_hero_mobile.jpg": 246,
	"./thumbnails/04_hero_tablet.jpg": 247,
	"./thumbnails/06_hero_desktop.jpg": 248,
	"./thumbnails/06_hero_mobile.jpg": 249,
	"./thumbnails/06_hero_tablet.jpg": 250,
	"./thumbnails/07_hero_desktop.jpg": 251,
	"./thumbnails/07_hero_mobile.jpg": 252,
	"./thumbnails/07_hero_tablet.jpg": 253,
	"./thumbnails/08_hero_desktop.jpg": 254,
	"./thumbnails/08_hero_mobile.jpg": 255,
	"./thumbnails/08_hero_tablet.jpg": 256,
	"./thumbnails/10_hero_desktop.jpg": 257,
	"./thumbnails/10_hero_mobile.jpg": 258,
	"./thumbnails/10_hero_tablet.jpg": 259,
	"./thumbnails/11b_hero_desktop.jpg": 260,
	"./thumbnails/11b_hero_mobile.jpg": 261,
	"./thumbnails/11b_hero_tablet.jpg": 262,
	"./thumbnails/12b_hero_desktop.jpg": 263,
	"./thumbnails/12b_hero_mobile.jpg": 264,
	"./thumbnails/12b_hero_tablet.jpg": 265,
	"./thumbnails/Corteva_Do_More_with_Less.jpg": 266,
	"./thumbnails/Corteva_From_Data_to_Decision.jpg": 267,
	"./thumbnails/Tanzania-Queen-and-Son-small.jpg": 268,
	"./thumbnails/Thailand.jpg": 269,
	"./thumbnails/artOfPrecision-desktop.jpg": 270,
	"./thumbnails/brazil_old_pastures.jpg": 271,
	"./thumbnails/cracking-the-code.jpg": 272,
	"./thumbnails/farmingWithNoRain-desktop.jpg": 273,
	"./thumbnails/foodByPrescription-desktop.jpg": 274,
	"./thumbnails/howTheWorldGrow-desktop.jpg": 275,
	"./thumbnails/seeds-of-change-desktop.jpg": 276,
	"./thumbnails/silicon-farm-thumbnail.jpg": 277,
	"./videoposters/Corteva_Do_More_with_Less-desktop.jpg": 278,
	"./videoposters/Corteva_Do_More_with_Less-mobile.jpg": 279,
	"./videoposters/Corteva_Do_More_with_Less-tablet.jpg": 280,
	"./videoposters/Corteva_From_Data_to_Decision-desktop.jpg": 281,
	"./videoposters/Corteva_From_Data_to_Decision-mobile.jpg": 282,
	"./videoposters/Corteva_From_Data_to_Decision-tablet.jpg": 283,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-desktop.jpg": 284,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-mobile.jpg": 285,
	"./videoposters/Corteva_How_the_world_grows_TMT-CORT003-120-tablet.jpg": 286,
	"./videoposters/Farming_where_it_doesnt_rain_tablet.png": 287,
	"./videoposters/TMT-CORT010-120-desktop.jpg": 288,
	"./videoposters/TMT-CORT010-120-mobile.jpg": 289,
	"./videoposters/TMT-CORT010-120-tablet.jpg": 290,
	"./videoposters/Tanzania-Queen-and-Son-small-desktop.jpg": 291,
	"./videoposters/Tanzania-Queen-and-Son-small-mobile.jpg": 292,
	"./videoposters/Tanzania-Queen-and-Son-small-tablet.jpg": 293,
	"./videoposters/Thailand-desktop.jpg": 294,
	"./videoposters/Thailand-mobile.jpg": 295,
	"./videoposters/Thailand-tablet.jpg": 296,
	"./videoposters/art-of-precision.jpg": 297,
	"./videoposters/brasil_new_pastures-desktop.jpg": 298,
	"./videoposters/brasil_new_pastures-mobile.jpg": 299,
	"./videoposters/brasil_new_pastures-tablet.jpg": 300,
	"./videoposters/cracking-the-code-desktop.jpg": 301,
	"./videoposters/cracking-the-code-mobile.jpg": 302,
	"./videoposters/cracking-the-code-tablet.jpg": 303,
	"./videoposters/seeds-of-change-desktop.jpg": 304,
	"./videoposters/seeds-of-change-mobile.jpg": 305,
	"./videoposters/seeds-of-change-tablet.jpg": 306,
	"./videoposters/silicon-farm-poster-desktop.jpg": 307,
	"./videoposters/silicon-farm-poster-mobile.jpg": 308,
	"./videoposters/silicon-farm-poster-tablet.jpg": 309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 523;